export default __webpack_public_path__ + "static/cduncan-b2c79c856fbabd91dba213175bd18b6b.png";